import { useEffect, useMemo } from 'react'
import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { Container } from '../../components/Container/Container'
import { Menu } from '../../components/Menu/Menu'
import { Status } from '../../components/Status'
import { Separator } from '../../components/Separator/Separator'
import { CONTRACT_CATEGORY_DETAILS_BREADCRUMBS } from './constants'
import { getUser } from '../../redux/store/user/getters'
import { canSeeMyContracts, safeString } from '../../helper/common'
import useRouter from '../../hooks/useRouter'
import { useContractCategoryDetailsContext } from './Providers/ContractCategoryDetailsContextProvider'
import { getStatusLabel } from './utils'
import { ReactComponent as EventSchedule16 } from 'assets/svg/EventSchedule16.svg'
import { contractCategoryDetailsRoute } from './routes'
import {
  CATEGORY_STATUS_NAME,
  CATEGORY_STATUS_TO_CLASSNAME
} from '../Categories/constants'
import './styles.scss'
import { ContractCategoryStatus } from '../Categories/types'

export const ContractCategoryDetailsContainer = ({ children }) => {
  const router = useRouter()
  const { state, actions } = useContractCategoryDetailsContext()
  const { activeTab, tabs } = state
  const { setActiveTab } = actions
  const { tab } = useParams()
  const RenderedActions = <></>

  const user = useSelector(getUser)

  const userCanSeeMyContracts = canSeeMyContracts(user.role)

  const title = state.isNewContractCategory
    ? 'Set up category'
    : state.details.contract_category_name

  useEffect(() => {
    setActiveTab(safeString(tab || contractCategoryDetailsRoute.general))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tab])

  const RenderedMenu = useMemo(() => {
    const handleSelectTab = (e) => {
      setActiveTab(e.key)
      router.push(e.key)
    }

    return (
      <>
        {state.isNewContractCategory ? null : (
          <Menu
            mode="horizontal"
            onSelect={handleSelectTab}
            selectedKeys={[activeTab]}
            defaultSelectedKeys={[activeTab]}
            items={tabs}
          />
        )}
      </>
    )
  }, [activeTab, router, setActiveTab, tabs, state.isNewContractCategory])

  const RenderedStatus = useMemo(() => {
    const statusLabel = getStatusLabel(state.details)
    if (
      state.details.status === ContractCategoryStatus.INACTIVE ||
      !state.details.status
    )
      return null
    return (
      state.details.status && (
        <div className="contract-category-status row align-center gap-12">
          {statusLabel && (
            <>
              <div className="contract-category-status__date-label row align-center gap-4">
                <EventSchedule16 />
                {statusLabel}
              </div>
              <Separator
                className="contract-category-status__separator"
                vertical
              />
            </>
          )}
          <Status.Default
            className={CATEGORY_STATUS_TO_CLASSNAME[state.details.status]}
          >
            {CATEGORY_STATUS_NAME[state.details.status]}
          </Status.Default>
        </div>
      )
    )
  }, [state.details])

  const breadcrumbs = CONTRACT_CATEGORY_DETAILS_BREADCRUMBS(
    title,
    userCanSeeMyContracts
  )

  return (
    <Container
      title={title}
      breadcrumbs={breadcrumbs}
      actions={RenderedActions}
      menu={RenderedMenu}
      status={RenderedStatus}
    >
      {children}
    </Container>
  )
}
